module.exports = "<p>{{customMac|e}}</p>\n";
